import React from 'react'
import { Box, Text, chakra } from '@chakra-ui/react'
import { CheckmarkCircle2 } from '@emotion-icons/evaicons-solid/CheckmarkCircle2'

const SuccessIcon = chakra(CheckmarkCircle2)

export const NewsLetterSubmitted = () => {
    return (
        <>
            <SuccessIcon boxSize="70px" color="green" />
            <Box textAlign={{ base: 'center', md: 'left' }}>
                <Text
                    variant="functionalSemiBold"
                    fontSize={{ md: '30px' }}
                    lineHeight={{ md: '46px' }}
                    display={{ base: 'none', sm: 'block' }}
                >
                    You have subscribed to our newsletter.
                </Text>
                <Text
                    variant="functionalSemiBold"
                    fontSize={{ md: '30px' }}
                    lineHeight={{ md: '46px' }}
                >
                    Thank you!
                </Text>
            </Box>
        </>
    )
}
